function setKeyValueInObject(key: string, value: any, object: object): any {
  return {
    ...object,
    [key]: value,
  };
}

export { setKeyValueInObject };
